import { dataAPI } from "../api"

export const getAttachment = (id: number): Promise<Resources.Attachment> =>
    dataAPI
        .getJSON<Api.ODataGetResourceResponse<Api.AttachmentResource>>(
            `attachments(${id})`,
        )
        .then((Attachment) => {
            if (!Attachment.Id) {
                throw new Error("The attachment has no ID.")
            }
            if (!Attachment.FileName) {
                throw new Error("The attachment has no FileName.")
            }
            if (!Attachment.FileSize) {
                throw new Error("The attachment has no FileSize.")
            }
            const newAttachment: Resources.Attachment = {
                id: Attachment.Id,
                filename: Attachment.FileName,
                fileSize: Attachment.FileSize,
                doesExist: true,
            }

            return newAttachment
        })
